import * as React from 'react';
import { Link } from '@reach/router';
import classNames from 'classnames';

import Rating from './Rating';
import HeartButton from 'components/elements/HeartButton';
import Checkbox from 'components/elements/Checkbox';
import './Thumbnail.scss';

interface ThumbnailProps {
  src: string | null;
  alt: string;
  caption?: string | React.ReactChild;
  subcaption?: string;
  ownerName?: string;
  variant?: 'rectangle' | 'square' | 'original';
  size?: 'small' | 'default';
  background?: 'default' | 'dark';
  className?: string;
  rating?: number;
  isFavourite?: boolean;
  markFavouritePhoto?: () => void;
  showCheckbox?: boolean;
  isChecked?: boolean;
  linkTo?: string;
  onCheckboxChange?: (e: React.MouseEvent) => void;
  onImageClick?: (e: React.MouseEvent) => void;
}
const Thumbnail = (props: ThumbnailProps) => {
  const {
    src,
    alt,
    isFavourite,
    markFavouritePhoto,
    caption = '',
    subcaption = '',
    ownerName = '',
    variant = 'rectangle',
    size = 'default',
    className = '',
    background = 'default',
    rating = null,
    showCheckbox = false,
    isChecked = false,
    linkTo = '',
    onCheckboxChange = (e: React.MouseEvent) => {},
    onImageClick = (e: React.MouseEvent) => {},
  } = props;

  const image = (
    <div
      className={classNames('image-container', {
        'no-image': !src,
      })}
      onClick={onImageClick}
    >
      <div className={classNames('image-wrapper')}>
        {src && <img src={src} alt={alt} />}
      </div>
    </div>
  );

  return (
    <figure
      className={classNames(
        'Thumbnail',
        variant,
        className,
        `size-${size}`,
        `background-${background}`,
      )}
    >
      {!!linkTo ? <Link to={linkTo}>{image}</Link> : image}
      <div className="bottom-row">
        <div className="left-group">
          {!!showCheckbox && (
            <Checkbox onChange={onCheckboxChange} checked={isChecked} />
          )}
          {(caption || subcaption) && (
            <figcaption>
              {caption}
              {subcaption && <small>{subcaption}</small>}
            </figcaption>
          )}
        </div>
        <div className="right-group">
          {ownerName && (
            <span className="owner-name">{ownerName}</span>
          )}
          {rating !== null && <Rating value={rating} />}
          {isFavourite && !!markFavouritePhoto && (
            <HeartButton
              inline
              fill={isFavourite}
              className="thumbnail-favourite"
            />
          )}
        </div>
      </div>
    </figure>
  );
};
export default Thumbnail;
